import { parseExpressionAt } from 'acorn'
import { ancestor } from 'acorn-walk'
import { generate, GENERATOR } from 'astring'

export function guardLoop(input: string) {
  const ast = parseExpressionAt(input, 0, {
    ecmaVersion: 'latest'
  })
  ancestor(ast, {
    ForStatement(node, state, ancestors) {
      addLoopGuard(node, ancestors)
    },
    WhileStatement(node, state, ancestors) {
      addLoopGuard(node, ancestors)
    }
  })
  return generate(ast, {
    generator: GENERATOR,
    indent: '',
    lineEnd: ''
  })
}

// 添加循环守护
function addLoopGuard(node: any, ancestors: any[]) {
  const guardStatements = [
    {
      expression: {
        argument: {
          name: `__r_loopCount`,
          type: 'Identifier'
        },
        operator: '++',
        prefix: false,
        type: 'UpdateExpression'
      },
      type: 'ExpressionStatement'
    },
    {
      consequent: {
        argument: {
          arguments: [
            {
              type: 'Literal',
              value: 'Potential infinite loop: exceeded 100001 iterations'
            }
          ],
          callee: {
            name: 'RangeError',
            type: 'Identifier'
          },
          type: 'NewExpression'
        },
        type: 'ThrowStatement'
      },
      test: {
        left: {
          name: '__r_loopCount',
          type: 'Identifier'
        },
        operator: '>',
        right: {
          type: 'Literal',
          value: 100_000
        },
        type: 'BinaryExpression'
      },
      type: 'IfStatement'
    }
  ]

  // 将守护代码块插入循环体
  if (Array.isArray(node.body?.body)) {
    // @ts-ignore
    node.body.body = [...guardStatements, ...node.body.body]
  } else {
    node.body = {
      body: [...guardStatements, node.body],
      type: 'BlockStatement'
    }
  }

  // 将计数器变量插入父级节点
  const parent = ancestors.at(-2) // 获取父节点
  const loopCountVar = {
    declarations: [
      {
        id: {
          name: '__r_loopCount',
          type: 'Identifier'
        },
        init: {
          type: 'Literal',
          value: 0
        },
        type: 'VariableDeclarator'
      }
    ],
    kind: 'var',
    type: 'VariableDeclaration'
  }

  parent.body = Array.isArray(parent.body)
    ? [loopCountVar, ...parent.body]
    : {
        body: [loopCountVar, parent.body],
        type: 'BlockStatement'
      }
}
